import { Box, Text, Button } from '@chakra-ui/react';

import { useAppSelector } from 'hooks';
import { useResendToBroker } from 'hooks/useResendToBroker';

import type { RootState } from 'store';

import { SIGNING_STATUS_COMPLETED } from 'variables/constants';

import StepContainer from './StepContainer';
import StepHeader from './StepHeader';
import StatusBadge from './StatusBadge';
import { FormStateKey, STEP_THREE_CONFIG } from './stepTypes';

interface StepThreeProps {
  formStateKey: FormStateKey;
}

const StepThree = ({ formStateKey }: StepThreeProps) => {
  const config = STEP_THREE_CONFIG[formStateKey];

  const uuid = useAppSelector((state: RootState) => state[formStateKey].uuid);
  const signing = useAppSelector(
    (state: RootState) => state[formStateKey].signing,
  );

  const isStepEnabled = signing?.status === SIGNING_STATUS_COMPLETED;

  const { handleResendToBroker, isResending } = useResendToBroker({
    uuid,
    successMessage: config.resendSuccessMessage,
  });

  return (
    <StepContainer isEnabled={isStepEnabled} showArrow={false}>
      <StepHeader
        stepNumber={3}
        title={config.title}
        isEnabled={isStepEnabled}
      />

      {isStepEnabled && (
        <Box mb="15px">
          <Text color="brand.500" fontSize="sm" fontWeight="semibold">
            Submission has been completed
          </Text>
        </Box>
      )}

      {isStepEnabled ? (
        <StatusBadge status="success">{config.successMessage}</StatusBadge>
      ) : (
        <StatusBadge status="disabled">{config.disabledMessage}</StatusBadge>
      )}

      {isStepEnabled && (
        <Button
          size="sm"
          colorScheme="blue"
          variant="outline"
          onClick={handleResendToBroker}
          isLoading={isResending}
          loadingText="Sending..."
          mt={3}
          w="100%"
        >
          Resend to Broker
        </Button>
      )}
    </StepContainer>
  );
};

export default StepThree;
